<template>
  <component :is="type + 'Add'" v-if="type" ref="addConsumerModal" />
</template>
<script>
import PowerAdd from './power/Add'
import GasAdd from './gas/Add'
import WaterAdd from './water/Add'
import HeatAdd from './heat/Add'

export default {
  components: {
    PowerAdd,
    GasAdd,
    WaterAdd,
    HeatAdd,
  },
  data() {
    return {
      id: null,
    }
  },
  computed: {
    type() {
      return this.$store.getters['energetic/getCurrentType']
    },
  },
  methods: {
    saveReport(e) {
      e.preventDefault()
      this.$refs.addConsumerModal.$validator.validateAll().then(() => {
        if (
          !this.$refs.addConsumerModal.errors.any() &&
          !this.$refs.addConsumerModal.loading
        ) {
          if (this.id) {
            this.$api
              .post('reports/edit_consumer', this.$refs.addConsumerModal.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-consumer')
                this.$root.$emit('reloadConsumerReportData')
              })
          } else {
            this.$api
              .post('reports/add_consumer', this.$refs.addConsumerModal.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-consumer')
                this.$root.$emit('reloadConsumerReportData')
              })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
